module.exports = __webpack_public_path__ + "img/introduce-text.7dd92267.png";